

export enum OrderState {
  PENDING = 'PENDING',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  AWAITING_ON_SITE_PAYMENT = 'AWAITING_ON_SITE_PAYMENT',
  PARTIALLY_COMPLETED = 'PARTIALLY_COMPLETED'
};
